@if (announcement(); as item) {
  <div class="announcement-popup" (click)="onBackdropClick($event)">
    <div class="announcement-popup__dialog default-border-radius" role="dialog" aria-modal="true"
      [attr.aria-label]="item.title">

      <button type="button" class="announcement-popup__close" (click)="close()" [attr.aria-label]="closeLabel()">
        <i class="fa-solid fa-xmark" aria-hidden="true"></i>
      </button>

      <img *ngIf="item.image" [src]="item.image.url" [alt]="item.image.alternativeText ?? ''"
        class="announcement-popup__image" />

      <div class="announcement-popup__body">
        <h3>{{ item.title }}</h3>

        <div class="content" *ngIf="item.content" [innerHTML]="item.content | bypassSecurity"></div>

        <div class="links" *ngIf="item.links?.length">
          <a *ngFor="let link of item.links; let i = index" href="{{ link.url }}"
            target="{{ link.openInNewTab ? '_blank' : '_self' }}" class="btn me-3 mt-3" (click)="close()"
            [ngClass]="item.links.length === 1 ? 'btn-light' : (i % 2 === 0 ? 'btn-dark' : 'btn-light')">
            {{ link.text }} <i class="fa-duotone fa-solid fa-circle-arrow-right fa-duotone-custom-colors"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
}
